import { useSyncStatus } from '../hooks/useSyncStatus'

export function SyncStatusIndicator() {
  const { configured, isAnyPending, hasError, statuses } = useSyncStatus()

  if (!configured) return null

  const syncedCount = Array.from(statuses.values()).filter((s) => s === 'synced').length

  let icon: string
  let label: string
  let colorClass: string

  if (isAnyPending) {
    icon = '↻'
    label = 'Saving...'
    colorClass = 'text-blue-500 bg-blue-50 border-blue-200'
  } else if (hasError) {
    icon = '⚠'
    label = 'Sync error'
    colorClass = 'text-red-500 bg-red-50 border-red-200'
  } else if (syncedCount > 0) {
    icon = '✓'
    label = 'Saved'
    colorClass = 'text-green-600 bg-green-50 border-green-200'
  } else {
    return null
  }

  return (
    <div
      className={`fixed bottom-4 right-4 z-50 flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium shadow-sm transition-all duration-300 ${colorClass} ${isAnyPending ? 'animate-pulse' : ''}`}
      role="status"
      aria-live="polite"
    >
      <span className={isAnyPending ? 'inline-block animate-spin' : ''}>{icon}</span>
      <span>{label}</span>
    </div>
  )
}
